// Araç Yönetimi - Vehicle Types

export enum VehicleType {
  CAR = 'CAR',
  VAN = 'VAN',
  MOTORCYCLE = 'MOTORCYCLE',
  TRUCK = 'TRUCK'
}

export enum VehicleStatus {
  ACTIVE = 'active',
  PASSIVE = 'passive',
  SCRAPPED = 'scrapped', // Hurdaya ayrıldı
  DELETED = 'deleted'    // Sistemden silindi (soft delete)
}

export enum VehicleAssignmentType {
  PERSONAL = 'personal', // Kişiye zimmetlenebilir
  POOL = 'pool'          // Havuz aracı: zimmetlenmez, uygun saatlerde herkes kullanabilir
}
export interface VehicleAssignment {
  id: number;
  vehicleId: number;
  assigneeId: number;
  assignedAt: string;
  returnedAt?: string;
  odometerOnAssignment: number;
  odometerOnReturn?: number;
  assignee?: {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
  };
  assignedTo?: {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
  };
}

export type VehicleUsageActivityType = 'VISIT' | 'DELIVERY' | 'MAINTENANCE' | 'OTHER' | 'OFFICE';

export type VehicleUsageActivityStatus =
  | 'PENDING_APPROVAL'
  | 'PLANNED'
  | 'COMPLETED'
  | 'CANCELLED'
  | 'REJECTED';

/** Aracın hangi çalışan tarafından hangi saha aktivitesinde kullanıldığı (en yeni önce, max 100) */
export interface VehicleUsageHistoryItem {
  activityId: number;
  title: string;
  type: VehicleUsageActivityType | null;
  status: VehicleUsageActivityStatus;
  startDate: string;
  endDate: string | null;
  completedAt: string | null;
  user: { id: number; firstName: string; lastName: string } | null;
}

export interface Vehicle {
  id: number;
  companyId: number;
  name: string;
  plateNumber: string;
  brand: string;
  model: string;
  year: number;
  type: VehicleType;
  status: VehicleStatus;
  assignmentType?: VehicleAssignmentType;
  currentOdometer?: number;
  createdAt: string;
  updatedAt: string;
  currentAssignment?: VehicleAssignment;
  assignmentHistory?: VehicleAssignment[];
  usageHistory?: VehicleUsageHistoryItem[];
}

export interface CreateVehicleDTO {
  name: string;
  plateNumber: string;
  brand: string;
  model: string;
  year: number;
  type: VehicleType;
  assignmentType?: VehicleAssignmentType;
}

export interface UpdateVehicleDTO {
  name?: string;
  plateNumber?: string;
  brand?: string;
  model?: string;
  year?: number;
  type?: VehicleType;
  status?: VehicleStatus;
  assignmentType?: VehicleAssignmentType;
  currentOdometer?: number;
}

export interface AssignVehicleDTO {
  assigneeId: number;
  odometer: number;
}

export interface ReturnVehicleDTO {
  returnOdometer: number;
  notes?: string;
}
